import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { MgpGaugeChart } from '../components/MgpGaugeChart/MgpGaugeChart';
import { goalsSelector } from '../MoneyGuidProSelectors';
import { goalsReducerPrefix } from '../MoneyGuideProConstants';
import { ResultsWrapper, ResultsHeading, ResultsText } from './GoalsStyles';
import { TabProps } from '../MoneyGuideProTypes';
import { Tab } from '../Tab/Tab';
import { Box } from '../../CommonComponents/OPL/Box/Box';
import { Text } from '../../CommonComponents/OPL/Text/Text';

export const Goals: React.FC<TabProps> = ({ id, clientId }) => {
  const data = useSelector(goalsSelector);

  return (
    <Tab
      tabTitle="Reaching Your Goals"
      mgpItemId={id}
      clientId={clientId}
      asOfDate={data ? data.asOfDate : null}
      reducerPrefix={goalsReducerPrefix}
      isEmpty={data === null}
      isPristine={data === undefined}
    >
      {data ? (
        <Box mx="4">
          <MgpGaugeChart data={data.chartData} />
          {typeof data.chartData.value === 'number' && (
            <ResultsWrapper>
              <ResultsHeading>Results</ResultsHeading>
              <Text as="p" fontSize="h6">
                If you implement the following suggestion, there is a{' '}
                {Math.round(data.chartData.value)}% likelihood of funding all of the financial goals
                in your plan.
              </Text>
            </ResultsWrapper>
          )}
        </Box>
      ) : null}
    </Tab>
  );
};
